import React, {Component} from 'react'
import {Query} from 'react-apollo'
import PropTypes from 'prop-types'
import LogService from '../rate-gql/services/log-service'
import {DATES_QUERY} from './graphql/queries/dates'
// eslint-disable-next-line tree-shaking/no-side-effects-in-initialization
import withCacheClient from '@cred/shared/hoc/withCacheClient'

const months = [
  'January', 'February', 'March',
  'April', 'May', 'June', 'July',
  'August', 'September', 'October',
  'November', 'December'
]

class DateGQL extends Component {
  static propTypes = {
    rateType: PropTypes.string.isRequired,
    vertical: PropTypes.string,
    lenderSlug: PropTypes.string,
    term: PropTypes.number,
    variable: PropTypes.bool,
    name: PropTypes.string
  }

  static defaultProps = {
    rateType: 'index',
    term: null,
    variable: null,
    name: 'LIBOR'
  }

  queryHandler = ({loading, error, data}) => {
    const {className} = this.props

    if (error) {
      LogService.error(`[Rates] Error getting a rate: ${error}`)

      return null
    }

    if (loading) {
      return null
    }

    return <span className={className}>{this.getDateValue(data)}</span>
  }

  getDateValue(data) {
    const rawValue = this.getDateRawValue(data)

    if (rawValue) {
      let date = rawValue.split(' ')[0],
        dateArr = date.split('-')

      return `${months[parseInt(dateArr[1]) - 1]} ${parseInt(dateArr[2])}, ${dateArr[0]}`
    }
  }

  getDateRawValue(data) {
    if (data && data.searchRates[0]) {
      return data.searchRates[0].publishedFrom
    }
  }

  render() {
    const {rateType, vertical, lenderSlug, term, variable, name} = this.props,
      args = {rateType, vertical, lenderSlug, term, variable, name}

    return (
      <Query query={DATES_QUERY} variables={{args, published: true}}>
        {this.queryHandler}
      </Query>
    )
  }
}

export {DateGQL}

export default /*#__PURE__*/ withCacheClient(DateGQL)
